<template>
  <section class="premium-container">
    <div class="flex-1">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <section class="flex">
          <div
            class="premium-content"
            :class="{
              'mock-refer': mockRefer
            }">
            <template>
              <div class="tr-container bar">
                <div class="tr">
                  <span class="bold">Remaining Amount</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">New Amount</span>
                  <v-checkbox
                    v-if="!info"
                    v-model="is_manual_quote"
                    :isBoolean="false"
                    :disabled='manual_checkbox_disable'>Manual</v-checkbox>
                </div>
              </div>
              <template v-for="({ item, name, style, min_base_prm, name2 }, index) in premiumItem">
                <div
                  v-if="style == 1"
                  :key="index"
                  class="tr-container">
                  <div class="tr">
                    <span>{{ item }}</span>
                    <span class="text-right">{{ oldForm[name] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span>{{ item }}</span>
                    <span>
                      <el-form-item :prop="name">
                        <v-input
                          v-model="formData[name]"
                          :disabled="buttonDisabled || info"
                          prepend="$"
                          :keyFloatNumber="true"
                          maxlength="8"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                  </div>
                </div>

                <div
                  v-if="style == 2"
                  :key="index"
                  class="tr-container">
                  <div class="tr">
                    <span>
                      {{ item }}
                      <span v-if="name == 'cfd' && oldForm[`${name}_pct`] != oldForm['ncd_pct']">( {{oldForm['ncd_pct']}}% )</span>
                    </span>
                    <span class="text-center">{{ oldForm[`${name}_pct`] }}%</span>
                    <span class="text-right">{{ oldForm[`${name}_amt`] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span>{{ item }}</span>
                    <span>
                      <el-form-item :prop="`${name}_pct`">
                        <v-input
                          v-model="formData[`${name}_pct`]"
                          :disabled="buttonDisabled || info"
                          append="%"
                          :keyFloatNumber="true"
                          maxlength="8"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                    <span class="text-right">{{ newPremium[`${name}_amt`] | formatMoney(2, true) }}</span>
                  </div>
                </div>

                <div
                  v-if="style == 3"
                  :key="index"
                  class="tr-container">
                  <div class="tr">
                    <span>{{ item }}</span>
                    <span class="text-right">{{ oldForm[`${name}_vl`] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span>{{ item }}</span>
                    <span
                      class="text-right">{{ newPremium[`${name}_vl`] | formatMoney(2, true) }}</span>
                  </div>
                </div>

                <div
                  v-if="style == 4"
                  :key="index"
                  class="tr-container bar">
                  <div class="tr">
                    <span class="bold">{{ item }}</span>
                    <span
                      v-if="name=='basic_prm' && min_base_prm"
                      class="bold">(Min. {{ min_base_prm}})</span>
                    <span class="bold text-right">{{ oldForm[name] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span class="bold">{{ item }}</span>
                    <!--                    <span-->
                    <!--                      v-if="name=='basic_prm' && min_base_prm"-->
                    <!--                      class="bold">(Min. {{ min_base_prm}})</span>-->
                    <span
                      v-if="name=='basic_prm' && min_base_prm"
                      class="flex flex-align-center">
                      <v-checkbox
                        v-model="formData.min_charge_allow"
                        :is-boolean="false"
                        :disabled="buttonDisabled || info"
                        @change="handlerGetQuoteMain"></v-checkbox>
                      <span
                        class="bold mg-l-5">(Min. {{ min_base_prm}})</span>
                    </span>
                    <span
                      class="bold text-right">{{ newPremium[name] | formatMoney(2, true) }}</span>
                  </div>
                </div>

                <div
                  v-if="style == 5 && oldForm.benefit_premium&&name!='total_mul'"
                  :key="index"
                  class="tr-container">
                  <div class="tr">
                    <span>{{ item }}</span>
                    <span class="text-right">{{ oldForm.benefit_premium[name2] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span>{{ item }}</span>
                    <span>
                      <el-form-item :prop="name">
                        <v-input
                          v-model="formData.benefit_premium[name2]"
                          :disabled="buttonDisabled || info"
                          prepend="$"
                          :keyFloatNumber="true"
                          maxlength="8"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                  </div>
                </div>
                <div
                  v-if="style == 5&&name=='total_mul'&&productId==11"
                  :key="index"
                  class="tr-container">
                  <div class="tr">
                    <span>
                      {{ item }}
                      <span v-if="name == 'cfd' && oldForm[`${name}_pct`] != oldForm['ncd_pct']">( {{oldForm['ncd_pct']}}% )</span>
                    </span>
                    <span class="text-center">{{ oldForm[`${name}_pct`] }}%</span>
                    <span class="text-right">{{ oldForm[`${name}_amt`] | formatMoney(2, true) }}</span>
                  </div>
                  <div
                    v-if="!mockRefer"
                    class="tr">
                    <span>{{ item }}</span>
                    <span>
                      <el-form-item :prop="`${name}_pct`">
                        <v-input
                          v-model="formData[`${name}_pct`]"
                          :disabled="buttonDisabled || info"
                          append="%"
                          :keyFloatNumber="true"
                          maxlength="8"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain"
                        />
                      </el-form-item>
                    </span>
                    <span class="text-right">{{ newPremium[`${name}_amt`] | formatMoney(2, true) }}</span>
                  </div>
                </div>
              </template>

              <div
                v-if="productId == 11"
                class="tr-container">
                <div class="tr">
                  <span>MIB</span>
                  <span class="text-center">{{ oldForm['mib_pct'] }}%</span>
                  <span class="text-right">{{ oldForm['mib_vl'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>MIB</span>
                  <span>
                    <el-form-item prop="mib_pct">
                      <v-input
                        v-model="formData.mib_pct"
                        :disabled="buttonDisabled || info"
                        append="%"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                  <span class="text-right">{{ newPremium['mib_vl'] | formatMoney(2, true) }}</span>
                </div>
              </div>
              <div
                v-if="classId == 21 || classId == 26 || classId == 24"
                class="tr-container">
                <div class="tr">
                  <span>EC Levy</span>
                  <span
                    v-if="classId == 24"
                    class="text-center">{{ oldForm['ec_levy_pct'] }}%</span>
                  <span class="text-right">{{ oldForm['ec_levy_vl'] | formatMoney(2, true) }}</span>
                </div>
                <!-- <div
                  v-if="(!mockRefer && productId == 15) || !isRefer"
                  class="tr">
                  <span>EC Levy</span>
                  <span class="text-right">{{ newPremium['ec_levy_vl'] | formatMoney(2, true) }}</span>
                </div> -->
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>EC Levy</span>
                  <template v-if="classId == 24">
                    <span>
                      <el-form-item prop="ec_levy_pct">
                        <v-input
                          v-model="formData.ec_levy_pct"
                          :disabled="buttonDisabled || info"
                          append="%"
                          :keyFloatNumber="true"
                          maxlength="8"
                          @blur="handlerGetQuoteMain"
                          @keyEnter="handlerGetQuoteMain" />
                      </el-form-item>
                    </span>
                    <span class="text-right">{{ newPremium['ec_levy_vl'] | formatMoney(2, true) }}</span>
                  </template>
                  <template v-else>
                    <el-form-item prop="ec_levy_vl">
                      <v-input
                        v-model="formData.ec_levy_vl"
                        :disabled="buttonDisabled || info"
                        prepend="$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </template>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>IA Levy</span>
                  <span class="text-center">{{ oldForm['ia_levy_pct'] }}%</span>
                  <span class="text-right">{{ oldForm['ia_levy_vl'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>IA Levy</span>
                  <span>
                    <el-form-item prop="ia_levy_pct ">
                      <v-input
                        v-model="formData.ia_levy_pct"
                        :disabled="buttonDisabled || info"
                        append="%"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                  <span class="text-right">{{ newPremium['ia_levy_vl'] | formatMoney(2, true) }}</span>
                </div>
              </div>
              <div class="tr-container bar">
                <div class="tr">
                  <span class="bold">Gross Premium</span>
                  <span class="bold text-right">{{ oldForm['gross'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">Gross Premium</span>
                  <span
                    class="bold text-right">{{ newPremium['gross'] | formatMoney(2, true) }}</span>
                </div>
              </div>


              <!--discount  -->
              <div class="tr-container">
                <div class="tr">
                  <span>Renew Discount ({{ oldForm['renew_disc_pct']}})%</span>
                  <span class="text-right">{{ oldForm['renew_disc_prm'] | formatMoney(2, true)  }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>Renew Discount ({{ newPremium['renew_disc_pct']||0}})%</span>
                  <span class="text-right">{{ newPremium['renew_disc_prm'] | formatMoney(2, true)  }}</span>

                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>Referral Discount</span>
                  <span class="text-right">{{ -oldForm['code_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>Referral Discount</span>
                  <span>
                    <el-form-item prop="code_disc_prm">
                      <v-input
                        v-model="formData['code_disc_prm']"
                        :disabled="!isFina"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>Coupon Discount</span>
                  <span class="text-right">{{ -oldForm['coupon_vl'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>Coupon Discount</span>
                  <span>
                    <el-form-item prop="coupon_vl">
                      <v-input
                        v-model="formData['coupon_vl']"
                        :disabled="true"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>Promo Discount</span>
                  <span class="text-right">{{ -oldForm['promo_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>Promo Discount</span>
                  <span>
                    <el-form-item prop="promo_disc_prm">
                      <v-input
                        v-model="formData['promo_disc_prm']"
                        :disabled="true"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>Manual Discount</span>
                  <span class="text-right">{{ -oldForm['spec_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>Manual Discount</span>
                  <span>
                    <el-form-item prop="spec_disc_prm">
                      <v-input
                        v-model="formData['spec_disc_prm']"
                        :disabled="info"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div
                v-if="productId == 11"
                class="tr-container">
                <div class="tr">
                  <span>MIB Discount</span>
                  <span class="text-right">{{ -oldForm['mib_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>MIB Discount</span>
                  <span>
                    <el-form-item prop="mib_disc_prm">
                      <v-input
                        v-model="formData['mib_disc_prm']"
                        :disabled="info"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div
                v-if="classId == 21 || classId == 26 || classId == 24"
                class="tr-container">
                <div class="tr">
                  <span>EC Levy Discount</span>
                  <span class="text-right">{{ -oldForm['ec_levy_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>EC Levy Discount</span>
                  <template>
                    <el-form-item prop="ec_levy_disc_prm">
                      <v-input
                        v-model="formData['ec_levy_disc_prm']"
                        :disabled="info"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </template>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span>IA Levy Discount</span>
                  <span class="text-right">{{ -oldForm['ia_levy_disc_prm'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span>IA Levy Discount</span>
                  <span>
                    <el-form-item prop="ia_levy_disc_prm">
                      <v-input
                        v-model="formData['ia_levy_disc_prm']"
                        :disabled="info"
                        prepend="-$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        @blur="handlerGetQuoteMain"
                        @keyEnter="handlerGetQuoteMain" />
                    </el-form-item>
                  </span>
                </div>
              </div>
              <div class="tr-container bar">
                <div class="tr">
                  <span class="bold">Amount</span>
                  <span class="text-right bold">{{ oldForm['payable'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">Amount</span>
                  <span class="text-right bold">{{ formData['payable'] | formatMoney(2, true) }}</span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span class="bold">Insurer Admin Charge</span>
                  <span class="text-right bold">{{ oldForm['insurer_handling_fee'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">Insurer Admin Charge</span>
                  <span
                    class="text-right bold">
                    <v-input
                      v-model="formData.insurer_handling_fee"
                      clearable
                      prepend="+$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerGetQuoteMain" /></span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span class="bold">Agency Admin Charge</span>
                  <span class="text-right bold">{{ oldForm['agency_handling_fee'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">Agency Admin Charge</span>
                  <span
                    class="text-right bold">
                    <v-input
                      v-model="formData.agency_handling_fee"
                      clearable
                      prepend="+$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerGetQuoteMain" /></span>
                </div>
              </div>
              <div class="tr-container">
                <div class="tr">
                  <span class="bold">Total Admin Charge</span>
                  <span class="text-right bold">{{ oldForm['handling_fee'] | formatMoney(2, true) }}</span>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold">Admin Charge</span>
                  <span
                    class="text-right bold">
                    <v-input
                      v-model="formData.handling_fee"
                      clearable
                      prepend="+$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      disabled
                      @blur="handlerGetQuoteMain" /></span>
                </div>
              </div>
              <!--              <div class="tr-container">-->
              <!--                <div class="tr">-->
              <!--                  <span class="bold way flex-align-center">-->
              <!--                    &lt;!&ndash;                    Way&ndash;&gt;-->
              <!--                    &lt;!&ndash;                    <v-radio-group&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      v-model="formData.way"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      :disabled="true"&ndash;&gt;-->
              <!--                    &lt;!&ndash;                      :list="wayList" />&ndash;&gt;-->
              <!--                  </span>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="tr-container bar">
                <div class="tr">
                  <span class="bold amount_title">Remaining Amount</span>
                  <span
                    v-if="formData.way == 1"
                    class="day">
                    <v-input
                      v-model="formData.old_remaining_days"
                      :disabled="info"
                      clearable
                      @blur="handlerGetQuoteMain"/> / <v-input
                        v-model="formData.old_cycle"
                        :disabled="true"
                        clearable
                        @blur="handlerGetQuoteMain" />
                  </span>
                  <span
                    v-if="formData.way == 2"
                    class="percent">
                    <!--                    <v-input-->
                    <!--                      v-model="formData.old_remaining_day_rate"-->
                    <!--                      :disabled="true"-->
                    <!--                      append="%"-->
                    <!--                      :keyFloatNumber="true"-->
                    <!--                      maxlength="8"-->
                    <!--                      @blur="handlerGetQuoteMain"-->
                    <!--                    />-->
                  </span>
                  <b class="text-right">{{ oldForm['remaining_premium'] | formatMoney(2, true) }}</b>
                </div>
                <div
                  v-if="!mockRefer"
                  class="tr">
                  <span class="bold amount_title">New Amount</span>
                  <span
                    v-if="formData.way == 1"
                    class="day">
                    <v-input
                      v-model="formData.new_remaining_days"
                      :disabled="true"
                      clearable
                      @blur="handlerGetQuoteMain" /> / <v-input
                        v-model="formData.new_cycle"
                        :disabled="info"
                        clearable
                        @blur="handlerGetQuoteMain" />
                  </span>
                  <span
                    v-if="formData.way == 2"
                    class="percent">
                    <!--                    <v-input-->
                    <!--                      v-model="formData.new_remaining_day_rate"-->
                    <!--                      :disabled="true"-->
                    <!--                      append="%"-->
                    <!--                      :keyFloatNumber="true"-->
                    <!--                      maxlength="8"-->
                    <!--                      @blur="handlerGetQuoteMain"-->
                    <!--                    />-->
                  </span>
                  <b class="text-right">{{ formData['remaining_premium'] | formatMoney(2, true) }}</b>
                </div>
              </div>
            </template>
          </div>
          <p
            v-if="mockRefer"
            class="refer-text">These modifications would need to be referred to insurer.</p>
        </section>

        <!-- extra benefit -->
        <div class="extra_benefit">
          <!-- cancel单 -->
          <template>
            <endorse-extra-benefit-table
              :info="info"
              :is-adjust="true"
              :manual_quote="is_manual_quote == 1"
              :oldExtraBenefit="oldForm.extra_benefits_content"
              :oldExtraBenefitContent="premiumData.extra_benefits_premium? premiumData.extra_benefits_premium.old_premium : null"
              :newExtraBenefit="premiumData.extra_benefits_premium? premiumData.extra_benefits_premium.new_premium : null"
              @dataProcess="getDataProcess"
              @updatePremium="updateEndorsePremium"></endorse-extra-benefit-table>
          </template>
        </div>
      </el-form>
    </div>
    <aside v-if="!mockRefer">
      <section class="aside-box">
        <div class="tr bar bold">
          <span>Summation</span>
        </div>
        <template>
          <div class="tr">
            <span>Previous Main Policy</span>
            <span class="text-right">{{oldForm['remaining_premium'] | formatMoney(2, true)}}</span>
          </div>
          <template v-for="(val, i) in extraArray">
            <div
              :key="'old'+ i"
              class="tr">
              <span>Previous {{val.name}}</span>
              <span class="text-right">{{val.old_p.content.remaining_premium | formatMoney(2, true)}}</span>
            </div>
          </template>
          <div class="tr bar bold">
            <span>Previous Remaining Amount</span>
            <span
              v-if="info"
              class="text-right">{{oldForm['remaining_premium'] | formatMoney(2, true)}}</span>
            <span
              v-else
              class="text-right">{{premiumData.diff_payable.old_remain_amount | formatMoney(2, true)}}</span>
          </div>

          <!-- new premium -->
          <div class="tr">
            <span>New Main Policy</span>
            <span class="text-right">{{formData['remaining_premium'] | formatMoney(2, true)}}</span>
          </div>
          <template v-for="(val, i) in extraArray">
            <div
              :key="'new'+i"
              class="tr">
              <span>New {{val.name}}</span>
              <span class="text-right">{{val.new_p.content.remaining_premium | formatMoney(2, true)}}</span>
            </div>
          </template>
          <div class="tr bar bold">
            <span>New Remaining Amount</span>
            <span
              v-if="info"
              class="text-right bold">{{formData['remaining_premium'] | formatMoney(2, true)}}</span>
            <span
              v-else
              class="text-right bold">{{premiumData.diff_payable.new_remain_amount | formatMoney(2, true)}}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Admin Charge</span>-->
          <!--            <span v-if="info">{{ formData.handling_fee | formatMoney(2, true) }}</span>-->
          <!--            <span v-else>-->
          <!--              <v-input-->
          <!--                v-model="formData.handling_fee"-->
          <!--                clearable-->
          <!--                prepend="+$"-->
          <!--                :keyFloatNumber="true"-->
          <!--                maxlength="8"-->
          <!--                @blur="handlerGetQuoteMain" />-->
          <!--            </span>-->
          <!--          </div>-->
          <div class="tr bar">
            <span>Total Payable</span>
            <span class="text-right">
              {{
                info? formData.amount: premiumData.diff_payable.payable | formatMoney(2, true)
              }}
            </span>
          </div>
        </template>
      </section>
      <section
        v-if="hasRemark"
        class="mg-t-15 remark-content">
        <policy-remark :remarkList="remarkList"></policy-remark>
      </section>
    </aside>

  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import {getOrderPremiumData} from '@/api/order'
import CancelExtraBenefitTable from './cancel-extra-benefit-table.vue'
import EndorseExtraBenefitTable from './endorsement-extra-benefit-table.vue'
import PolicyRemark from '@/views/records/policy/components/policy-remark'

export default {
  name: 'PremiumFormAdjustment',
  components:{
    PolicyRemark,
    EndorseExtraBenefitTable
  },
  mixins: [MixinFormat, MixinRules],
  props: {
    remarkList: {
      type: Array,
      default: () => ([])
    },
    classId: {
      type: [String, Number],
      default: 0,
    },
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    prePremium: {
      type: Object,
      default: () => ({})
    },
    newPremium: {
      type: Object,
      default: () => ({})
    },
    diffPayable: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
    mockRefer: {
      type: Boolean,
      default: false
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    premiumData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: null
    },
    hasRemark:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      premiumItem: [],
      formData: {
        way:2,
        old_remaining_day_rate:100,
        new_remaining_day_rate:100,
      },
      oldPremiumForm: null,
      remainPremium: [],
      way: 2,
      wayList:[
        {
          name: 'Days',
          id: 1
        },
        {
          name: 'Percentage',
          id: 2
        },
      ],
      old_remaining_days : '',
      old_cycle: 365,
      new_remaining_days : '',
      new_cycle: 365,
      old_percentage: 80,
      new_percentage: 80,
      personal_accident_extra_benefits: 0,
      private_car_extra_benefits: 0,
      extraArray: [],
      type: 1,  //1不可修改，2可以修改
      is_manual_quote:1,
      endorsement:{
        extra_benefits_content: {}
      }
    }
  },
  computed: {
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
    productId(){
      let {product_id} = this.$route.query
      return product_id
    },
    ticketId(){
      let {ticket_id} = this.$route.query||{}
      return ticket_id
    },
    cancelMain(){
      let count = 0
      this.remainPremium.map(item => {
        if(item.item == 'Remaining Premium'){
          count = item.amount
        }
      })
      return count
    },
    premiumForm() {
      return this.getPremiumForm()
    },
    oldAllExtraBenefit(){
      let arr =[]
      if(this.premiumData.extra_benefits_premium.old_premium){
        Object.keys(this.premiumData.extra_benefits_premium.old_premium).forEach(item => {
          arr.push(this.premiumData.extra_benefits_premium.old_premium[item])
        })
      }
      return arr
    },
    newAllExtraBenefit(){
      let arr =[]
      if(this.premiumData.extra_benefits_premium.new_premium){
        Object.keys(this.premiumData.extra_benefits_premium.new_premium).forEach(item => {
          arr.push(this.premiumData.extra_benefits_premium.new_premium[item])
        })
      }
      return arr
    },
    cancelExtraBenefit(){
      let arr = []
      if(this.premiumData.extra_benefits_premium){
        Object.keys(this.premiumData.extra_benefits_premium).forEach(item => {
          arr.push(this.premiumData.extra_benefits_premium[item])
        })
        return arr
      }
      return arr
    },
    manual_checkbox_disable(){
      return true
      // return this.type == 2
    },

    buttonDisabled(){
      return this.is_manual_quote == 0 && this.type == 1
    }
  },
  watch: {
    classId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getOrderPremiumData()
        }
      }
    },
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          this.formData = JSON.parse(JSON.stringify({
            ...val,
            cfd_pct: val['ncd_pct'],
            cfd_amt: val['ncd_vl']
          }))
          this.$set(this.formData, 'way', 2)
          this.$set(this.formData, 'new_remaining_day_rate', 100)
          this.$set(this.formData, 'old_remaining_day_rate', 100)
        }
      }
    },
    premiumForm: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('update-form', val)
      }
    },
    info:{
      immediate: true,
      handler(val){
        if(val){
          this.$set(this.formData, 'way', 2)
          this.$set(this.formData, 'new_remaining_days', this.form.remaining_days)
          this.$set(this.formData, 'new_cycle', this.form.cycle)
          this.$set(this.formData, 'new_remaining_day_rate', 100)
          this.$set(this.formData, 'remaining_premium', this.form.remaining_premium)
          this.$set(this.formData, 'old_remaining_days', this.oldForm.remaining_days)
          this.$set(this.formData, 'old_cycle', this.oldForm.cycle)
          this.$set(this.formData, 'old_remaining_day_rate', 100)
          this.$set(this.oldForm, 'remaining_premium', this.oldForm.remaining_premium)
        }
      }
    },
    premiumData: {
      immediate: true,
      deep: true,
      handler(val) {

        if(val.new_premium && Object.keys(val.new_premium).length > 0){
          if(val.old_premium.way){
            this.$set(this.formData, 'way', 2)
          }
          this.$set(this.formData, 'new_remaining_days', val.new_premium.remaining_days)
          this.$set(this.formData, 'new_cycle', val.new_premium.cycle)
          this.$set(this.formData, 'new_remaining_day_rate', 100)
          Object.assign(this.formData, val.new_premium)
        }
        if (val.diff_payable && JSON.stringify(val.diff_payable) != '{}') {
          let data = JSON.parse(JSON.stringify(val))
          const {diff_payable = {}, new_premium = {}, old_premium = {}, remain_premium = []} = data
          this.remainPremium = remain_premium

        }
        if(val.old_premium && Object.keys(val.old_premium).length > 0){
          if(val.old_premium.way){
            this.$set(this.formData, 'way', 2)
          }
          this.$set(this.formData, 'old_remaining_days', val.old_premium.remaining_days)
          this.$set(this.formData, 'old_cycle', val.old_premium.cycle)
          this.$set(this.formData, 'old_remaining_day_rate', 100)
          this.$set(this.oldForm, 'remaining_premium', val.old_premium.remaining_premium)
          this.$set(this.oldForm, 'payable', val.old_premium.payable)
        }
        if(val.type){
          this.type = val.type
        }
        if(val.extra_benefits_premium){
          let extraPremium = val.extra_benefits_premium
          if(extraPremium.new_premium){
            this.endorsement.extra_benefits_content.new_premium = extraPremium.new_premium
          }
          if(extraPremium.old_premium){
            this.endorsement.extra_benefits_content.old_premium = extraPremium.old_premium
          }
        }
        this.is_manual_quote = val.is_manual_quote || 1
        let {new_premium} = val||{}
        this.$set(this.formData, 'handling_fee', new_premium.handling_fee)
        this.$set(this.formData, 'insurer_handling_fee', new_premium.insurer_handling_fee)
        this.$set(this.formData, 'agency_handling_fee', new_premium.agency_handling_fee)
        this.$set(this.formData, 'min_charge_allow', new_premium.min_charge_allow)
        // 初始化数据，可能会因为手续费问题产生差异，所以这里重新计算一下
        this.inputHandlingFee(new_premium.handling_fee)
      }
    },

    type:{
      immediate: true,
      handler(val){
        if(val == 2){
          this.is_manual_quote = 1
        }
      }
    },

    is_manual_quote:{
      handler(val){
        if(val == 0){
          this.handlerGetQuoteMain()
        }
      }
    },

    'formData.benefit_premium':{
      immediate: true,
      deep: true,
      handler(val){
        if(JSON.stringify(val) === '[]'){
          this.formData.benefit_premium = {}
        }
      }
    }
  },
  created() {

  },
  methods: {
    updatePremium(type){
      // cancel单触发更新需要重新传表单参数
      this.remainPremium.map(item => {
        if(item.type == 3){
          this.cancelData.way = item.way
          this.cancelData.min_charge = item.min_charge
        }
        if(item.type == 4){
          this.cancelData.remaining_days = item.remaining_days
          this.cancelData.cycle = item.cycle
          this.cancelData.remaining_day_rate = item.remaining_day_rate
        }
      })
      this.$emit('updateCancelPremium', this.cancelData, type)
    },
    updateEndorsePremium(extra){
      this.endorsement.extra_benefits_content = extra
      this.handlerGetQuoteMain()
    },
    getDataProcess(extraArray){
      this.extraArray = extraArray
    },
    submitForm(type) {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          Object.assign(this.premiumForm,{
            is_manual_quote: this.is_manual_quote,
            benefit_premium: this.formData.benefit_premium
          })
          this.$emit('get-form', this.premiumForm, type)
        }
      })
    },
    handlerGetQuoteMain() {
      this.oldPremiumForm = JSON.parse(JSON.stringify(this.premiumForm))
      let params = {
        ...this.premiumForm,
        min_charge_allow:this.formData.min_charge_allow,
        agency_handling_fee:this.formData.agency_handling_fee,
        insurer_handling_fee:this.formData.insurer_handling_fee,
        extra_benefits_content: this.endorsement.extra_benefits_content,
        is_manual_quote: this.is_manual_quote,
        benefit_premium: this.formData.benefit_premium,
      }
      this.$emit('get-quote', {
        ...params
      })
    },
    inputHandlingFee(val) {
      this.$emit('input-handling', val)
    },
    checkParams() {
      const list = this.getInputItems()
      let result = true
      let diff = this.oldPremiumForm? false: true
      list.some(key => {
        if(this.formData[key] === '') {
          result = false
          return true
        }
        if(this.oldPremiumForm && this.formData[key] != this.oldPremiumForm[key]) {
          diff = true

        }
      })
      return result && diff
    },
    getPremiumForm() {
      const list = this.getInputItems()
      return list.reduce((result, item) => {
        result[item] = this.formData[item]
        return result
      }, {})
    },
    getInputItems() {
      // 獲取 input key list
      let list = this.premiumItem.reduce((result, items) => {
        const { item, name, style } = items
        if(style == 1) {
          result.push(name)
        }
        if(style == 2||style==5&&name=='total_mul') {
          result.push(`${name}_pct`)
        }
        return result
      }, [])
      list = [
        ...list,
        'spec_disc_prm',
        'handling_fee',
        'insurer_handling_fee',
        'agency_handling_fee',
        'code_disc_prm',
        'coupon_vl',
        'promo_disc_prm',
        'spec_disc_prm',
        'way',
        'new_remaining_days',
        'new_cycle',
        'new_remaining_day_rate',
        'old_remaining_days',
        'old_cycle',
        'old_remaining_day_rate',
        'mib_pct',
        'ia_levy_pct',
        'ec_levy_pct',
        'ec_levy_vl',
        'ia_levy_disc_prm',
        'mib_disc_prm',
        'ec_levy_disc_prm',
        'min_charge_allow'
      ]
      // if([12, 17].includes(Number(this.productId))) {
      //   list = [
      //     ...list,
      //     'ec_levy_pct'
      //   ]
      // }
      return list
    },
    network() {
      return {
        getOrderPremiumData: async () => {
          let company_id = this.form.company_id || ''
          let plan_id = (this.form.quote_coverage_list && this.form.quote_coverage_list.plan_info.plan_id) || this.form.plan_id || ''
          const { data } = await getOrderPremiumData({
            class_id: Number(this.classId),
            order_id: this.orderId,
            company_id,
            plan_id
          })
          this.premiumItem = data
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.premium-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  .premium-content {
    width: 100%;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    &.mock-refer {
      width: 50%;
    }
    .tr-container {
      display: flex;
      border-bottom: 1px solid #e1e4e8;
      &:last-child {
        border-bottom: 0;
      }
      &.bar {
        background: #f6f8fa;
      }
      &:first-child{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      &:last-child{
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      .tr {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 14px;
        color: #24292e;
        line-height: 17px;
        & > span {
          flex: 1;
        }
        &:nth-child(2) {
          border-left: 1px solid #E1E4E8;;
        }
        b{
          width: 100px;
        }
        .percent{
          flex: 0 0 auto;
          width: 100px;
        }
        .el-checkbox{
          align-items: center;
        }
      }
    }
    .tr-extra{
      display: flex;
      border-bottom: 1px solid #e1e4e8;
      .extra-content{
        display: flex;
        flex-direction: column;
        flex: 1;
        &:nth-child(1){
          .tr{
            border-right: 1px solid #E1E4E8;;
          }
        }

      }
      .extra-title{
        color: #24292e;
        font-weight: 500;
      }
      &:last-child {
        border-bottom: 0;
      }
      .tr {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        font-size: 14px;
        color: #24292e;
        line-height: 17px;
        border-bottom: 1px solid #e1e4e8;
        & > span {
          flex: 1;
        }
        &:last-child{
          border-bottom: 0;
        }
      }
    }
    .extra-content-cancel{
      display: flex;
      flex-direction: column;
      .tr-extra{
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #e1e4e8;
        .extra-title{
          color: #24292e;
          font-weight: 500;
        }
        &:last-child {
          border-bottom: 0;
        }
        .tr {
          //flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px;
          font-size: 14px;
          color: #24292e;
          line-height: 17px;
          border-bottom: 1px solid #e1e4e8;
          & > span {
            flex: 1;
          }
          &:last-child{
            border-bottom: 0;
          }
        }
      }
    }

  }
  aside {
    margin-left: 30px;
    min-width: 280px;
    .aside-box{
      border: 1px solid #e1e4e8;
      border-radius: 8px;
      margin-bottom: 10px;
    }
    .tr {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      font-size: 14px;
      color: #24292e;
      line-height: 17px;
      border-bottom: 1px solid #e1e4e8;
      & > span {
        flex: 1;
      }
      & > span:first-child {
        color: #586069;
        // font-weight: bold;
      }
      &:last-child {
        border-bottom: 0;
      }
      &.bar {
        background: #f6f8fa;
      }
      &:first-child{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      &:last-child{
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .bold {
    font-weight: bold;
  }
  .way{
    width: 100px;
  }
  .refer-text {
    margin-left: 20px;
    font-size: 16px;
    color: #91939A;
  }
  .v-radio-group{
    margin-left: 20px;
    display: inline-block;
  }
  .day{
    text-align: center;
    .el-input{
      width: 80px;
    }
  }
  .amount_title{
    flex: 0 0 auto !important;
    width: 200px;
  }
}
/deep/ .el-input-group__append {
  padding: 0 5px;
}
</style>
